import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { HotlineCallsTable } from '@/components/HotlineCallsTable'
import { Text } from '@mantine/core'
import { DateRangeAccordion } from '@/components/DateRangeAccordion'
import PageShell from '@/components/Common/PageShell'
import { requirePermission } from '@/utils/auth'
import { formatDateForUrl } from '@/utils/datetime'
import { parseAndValidateDates } from '@/utils/datetime'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'

const ROUTE_PATH = '/hotline-calls/$startDate/$endDate'

const HotlineCalls = () => {
  const { startDate: startDateParam, endDate: endDateParam } = Route.useParams()
  const navigate = useNavigate()
  const { t } = useTranslation('hotline')
  const [isRangeSelectionInProgress, setIsRangeSelectionInProgress] = useState(false)

  const navigateToDateRange = (newStartDate: Date, newEndDate: Date) => {
    navigate({
      to: ROUTE_PATH,
      params: {
        startDate: formatDateForUrl(newStartDate),
        endDate: formatDateForUrl(newEndDate),
      },
    })
  }

  const { startDate, endDate } = parseAndValidateDates(startDateParam, endDateParam)

  return (
    <PageShell title={t('hotlineCallsOverview')}>
      <DateRangeAccordion
        startDate={startDate}
        endDate={endDate}
        onRangeChange={navigateToDateRange}
        onRangeSelectionStateChange={setIsRangeSelectionInProgress}
      />
      {isRangeSelectionInProgress ? (
        <Text ta="center" c="dimmed" py="xl" fz="xl" fw={600}>
          {t('selectRangeToSeeData', { ns: 'common' })}
        </Text>
      ) : (
        <HotlineCallsTable startDate={startDate} endDate={endDate} tableKey="hotlineTableColumns" />
      )}
    </PageShell>
  )
}

export const Route = createFileRoute('/hotline-calls/$startDate/$endDate')({
  beforeLoad: () => requirePermission('hotline'),
  component: HotlineCalls,
  parseParams: params => ({
    startDate: params.startDate,
    endDate: params.endDate,
  }),
})

export default HotlineCalls
